import { sortBy } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
const util = require('./util.js');
class TimelineSystem {
  constructor(systems) {
    this.systems = systems;

    this.timelineEvents = {};
  }

  reset() {
    this.timelineEvents = {};
  }

  before(dt) {
  }

  after(dt) {
  }

  makeKey(ent, timeline) {
    return [timeline.name, ent.uuid.uuid].join('-');
  }

  update(dt, ent) {
    const timelines = Object.values(ent.timeline.timelines);

    const totalLength = ent.timeline.multi.length;
    for (let j = 0; j < totalLength; j++) {
      const o = ent.timeline.multi[j];
      const timeline = o.c;
      const component = o.component;
      const key = this.makeKey(ent, component);
      if (!this.timelineEvents[key]) {
        const slots = this.systems.findSlots(ent, component, null, null, true);

        const timeEvents = slots
          .filter( ({link}) => {
            return link.meta && typeof(link.meta.t) !== 'undefined';
          })
          .map( ({component,link}) => {
            const t = link.meta.t;
            const d = typeof(link.meta.d) !== 'undefined' ? parseFloat(link.meta.d) : -1
            return {
              component,
              t,
              d
            }
          });
        this.timelineEvents[key] = sortBy(timeEvents, "t");
      }
    }


    for (let j = 0; j < timelines.length; j++) {
      const timeline = timelines[j];

      timeline.prevT = timeline.t;
      timeline.t += dt / 1000;

      const key = this.makeKey(ent, timeline);
      const timeEvents = this.timelineEvents[key];
      for (let i = 0; i < timeEvents.length; i++) {
        const timeEvent = timeEvents[i];
        if (timeline.prevT <= timeEvent.t && timeline.t >= timeEvent.t) {
          this.systems.addComponent(ent, [timeEvent.component]);
        } 
        if (timeEvent.d !== -1) {
          const endTime = timeEvent.t + timeEvent.d;
          if (timeline.prevT < endTime && timeline.t >= endTime) {
            //const component = this.systems.Components[timeEvent.component.type];
            //console.log('remove component', component);
            const component = timeEvent.component;

            this.systems.removeComponentFromDefinition(ent, component);


          }
        }
      }
      //console.log("timeline is at", timeline.t);
    }

  }
}
export default TimelineSystem;
